module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"maxLength":"Must be less than 30 characters","Characters only":"Characters only","No numbers":"No numbers"},"es":{"maxLength":"Debe tener menos de 30 caracteres","Characters only":"Solo personajes","No numbers":"Sin números"},"sw":{"maxLength":"Lazima iwe chini ya herufi 30","Characters only":"Wahusika pekee","No numbers":"Hakuna nambari"}}')
  delete Component.options._Ctor
}
